<template>
    <div class="app-bar-wrapper">
        <div class="main-grid-right-sidebar-toggle">
            <button
                v-for="panel in panels"
                :key="panel.name"
                class="app-bar-btn"
                :class="{ active: activeRightPanel === panel.name && rightPanelOpened }"
                :title="panel.label"
                @click="openPanel(panel.name)"
            >
                <Icon :name="panel.icon" size="base" />
            </button>
        </div>

        <div class="right-panel-drawer" :class="{ open: rightPanelOpened }">
            <navigation-views v-if="activeRightPanel === 'NAV_HISTORY'" type="history" />
            <navigation-views v-else-if="activeRightPanel === 'NAV_MINIMIZED'" type="min" />
        </div>
    </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import Icon from '@common/icon/Icon.vue';

export default {
    name: 'AppBar',
    components: {
        Icon,
        'navigation-views': defineAsyncComponent(() => import('@common/navigation/navigationViews')),
    },
    props: {
        panels: {
            type: Array,
            default: () => [],
        },
    },
    emits: [],
    data() {
        return {
            rightPanelOpened: false,
            activeRightPanel: null,
        };
    },
    methods: {
        togglePanel() {
            this.rightPanelOpened = !this.rightPanelOpened;
            if (!this.rightPanelOpened) {
                this.activeRightPanel = null;
            }
        },
        openPanel(name) {
            if (this.activeRightPanel === name && this.rightPanelOpened) {
                this.rightPanelOpened = false;
                this.activeRightPanel = null;
                return;
            }
            this.activeRightPanel = name;
            this.rightPanelOpened = true;
        },
    },
};
</script>

<style scoped>
.app-bar-wrapper {
    display: contents;
}

.main-grid-right-sidebar-toggle {
    width: 3rem;
    background-color: var(--surface-subtle);
    border-left: 1px solid var(--border-color-default);
    padding: var(--space-3) 0;
    flex-shrink: 0;
    z-index: 1001;
    overflow-y: auto;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--space-2);
}

.app-bar-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2rem;
    height: 2rem;
    border: none;
    border-radius: var(--radius-xs);
    background: none;
    color: var(--text-color-body);
    cursor: pointer;
    transition: background-color 0.15s ease, color 0.15s ease;
}

.app-bar-btn:hover {
    background-color: var(--surface-subtle-primary);
    color: var(--text-color-title);
}

.app-bar-btn:focus-visible {
    outline: 2px solid var(--border-color-default-primary);
    outline-offset: -2px;
}

.app-bar-btn.active {
    background-color: var(--surface-default-primary);
    color: var(--text-color-inverse);
}

.app-bar-btn.active i {
    color: var(--text-color-inverse) !important;
}

.right-panel-drawer {
    position: absolute;
    top: 0;
    right: 3rem;
    bottom: 0;
    width: 300px;
    background-color: var(--surface-subtle);
    border-left: 1px solid var(--border-color-default);
    box-shadow: var(--shadow-1);
    transform: translateX(100%);
    transition: transform 0.25s ease;
    z-index: 1000;
    overflow-y: auto;
    overflow-x: hidden;
}

.right-panel-drawer.open {
    transform: translateX(0);
}
</style>
